(function () {

    'use strict';

    angular.module('asys')
        .config(initConfig)
        .run(initRun);

    initConfig.$inject = [
        '$injector',
        '$locationProvider',
        '$httpProvider',
        '$compileProvider',
        '$logProvider',
        '$ariaProvider',
        'AppConfigProvider',
        'IntegrationServiceProvider',
        'numbroProvider',
        '$analyticsProvider',
        '$animateProvider',
        '$localStorageProvider',
        '$sessionStorageProvider',
        '$sceDelegateProvider',
        '$urlMatcherFactoryProvider'
    ];
    function initConfig($injector, $locationProvider, $httpProvider, $compileProvider, $logProvider, $ariaProvider, AppConfigProvider, IntegrationServiceProvider, numbroProvider, $analyticsProvider, $animateProvider, $localStorageProvider, $sessionStorageProvider, $sceDelegateProvider, $urlMatcherFactoryProvider) {
        var AppConfig = AppConfigProvider.$get(),

            numbroLanguageSettings = numbroProvider.$get().cultureData('de-DE') || {
                delimiters: null,
                abbreviations: {},
                currency: null
            };

        $urlMatcherFactoryProvider.strictMode(false);

        $ariaProvider.config({
            tabindex: false,
            bindRoleForClick: false
        });
        IntegrationServiceProvider
            .mapping('vermittlernummer', {
                path: 'allgemeineDaten.vermittlernummer',
                value: {
                    id: null,
                    type: 'VERMITTLERNUMMER'
                },
                valueSetterPath: ['id', 'formatiert']
            })
            .mapping('anforderungsart', {
                path: 'allgemeineDaten.anforderungsart',
                value: {
                    wert: null,
                    typ: 'ANFORDERUNGSART'
                },
                valueSetterPath: ['wert']
            })
            .mapping('versicherungsbeginn', {
                path: function () {
                    return (AppConfig.ANGEBOT.tarifauskunftsdatumType || 'tarifauskunftsdatum') === 'versicherungsbeginn' ? 'allgemeineAntragsdaten.versicherungsbeginn' : 'allgemeineDaten.angebotsdatum';
                },
                value: null
            })
            .mapping('arbeitgeber', {
                path: 'antragsteller.arbeitgeber',
                value: {
                    wert: null,
                    typ: 'ARBEITGEBER'
                },
                valueSetterPath: ['wert']
            })
            .mapping('beruf', {
                path: 'antragsteller.beruf',
                value: {
                    wert: null,
                    typ: 'BERUF'
                },
                valueSetterPath: ['wert']
            })
            .mapping('nw', {
                path: 'antragsteller.netzwerk',
                value: {
                    wert: null,
                    typ: 'NETZWERK'
                },
                valueSetterPath: ['wert']
            })
            
            .mapping('oeffentlicherdienst', {
                path: 'antragsteller.imOeffentlichemDienstTaetig',
                value: null,
                valueSetter: function (obj, val) {
                    return (val === 'true' || val === true) ? true : false;
                }
            });

        IntegrationServiceProvider.setStoreName(AppConfig.ANGEBOT.tarifkuerzel);

        numbroLanguageSettings.abbreviations = {};

        $locationProvider.html5Mode(true);
        $localStorageProvider.setKeyPrefix('iplusjs-');
        $sessionStorageProvider.setKeyPrefix('iplusjs-');
        $sessionStorageProvider.setDeserializer(function (value) {
            try {
                return JSON.parse(value);
            } catch (e) {
                return value;
            }
        });

        $logProvider.debugEnabled(AppConfig.APP.logging.debugEnabled);
        $compileProvider.debugInfoEnabled(AppConfig.APP.debugInfoEnabled);
        $compileProvider.aHrefSanitizationTrustedUrlList(AppConfig.APP.regexAHrefSanitizationTrustedUrlList);

        numbroLanguageSettings.delimiters.thousands = '.';
        numbroProvider.setSettings('de-DE', numbroLanguageSettings);
        numbroProvider.setLanguage('de-DE');

        $analyticsProvider.settings.wgv = AppConfig.APP.tracking.wgv;
        $analyticsProvider.settings.wgv.initialPageLoad = true;
        $analyticsProvider.settings.etracker = AppConfig.APP.tracking.etracker;
        $analyticsProvider.settings.etracker.initialPageLoad = true;
        $analyticsProvider.settings.hurra = AppConfig.APP.tracking.hurra;

        $httpProvider.interceptors.push('AuthenticationInterceptor');
        $httpProvider.interceptors.push('ApiInterceptor');

        $animateProvider.classNameFilter(/\banimate\b/);

        $sceDelegateProvider.resourceUrlWhitelist([
            'self',
            AppConfig.ANGEBOT.waitHelperUrl
        ]);
    }

    initRun.$inject = [
        '$rootScope',
        '$log',
        '$window',
        '$anchorScroll',
        '$injector',
        'lodash',
        'AppConfig',
        'moment',
        'modernizr',
        '$analytics',
        '$sessionStorage'
    ];
    function initRun($rootScope, $log, $window, $anchorScroll, $injector, _, AppConfig, moment, modernizr, $analytics, $sessionStorage) {
        var IntegrationService = $injector.has('IntegrationService') && $injector.get('IntegrationService'),
            PaymentFrameService = $injector.has('PaymentFrameService') && $injector.get('PaymentFrameService'),
            PaymentOverlayService = $injector.has('PaymentOverlayService') && $injector.get('PaymentOverlayService'),
            NavigationService = $injector.has('NavigationService') && $injector.get('NavigationService'),
            WebMcpUtilsService = $injector.has('WebMcpUtilsService') && $injector.get('WebMcpUtilsService'),
            MiscUtilsService = $injector.has('MiscUtilsService') && $injector.get('MiscUtilsService');

        if (WebMcpUtilsService && angular.isFunction(WebMcpUtilsService.registerTool)) {
            WebMcpUtilsService.registerTool(AppConfig.APP.webMcpTarifberechnung);
        }

        $anchorScroll.yOffset = 130;
        moment.locale('de');

        angular.element($window.document.body).addClass('selectable');

        $analytics.setUserProperties({
            wgv: {
                session: MiscUtilsService.guid('##########'),
                getPageIndex: NavigationService.getPageIndex
            }
        });
        IntegrationService.checkPermissions();
        if ((/^https:\/\/www(.{0,1})?\.wgv\.de/).test($sessionStorage.closeUrl)) {
            IntegrationService.setIntegrationParams({ closeUrl: $sessionStorage.closeUrl });
        }

        delete $sessionStorage.closeUrl;

        $rootScope.$on('iplusjs:externalSidCreated', function () {
            IntegrationService.checkPermissions();
        });

        $window.addEventListener('message', function (event) {
            var message;

            if (
                (
                    !_.includes(AppConfig.INTEGRATION.messageOrigins, event.origin) &&
                    !_.includes(AppConfig.PAYMENT_FRAME.messageOrigins, event.origin) &&
                    !_.includes(AppConfig.PAYMENT_OVERLAY.messageOrigins, event.origin) &&
                    !_.includes(AppConfig.INTEGRATION.messageOrigins, '*')
                )
            ) {
                return;
            }

            if (_.isObject(event.data)) {
                message = event.data;
            } else {
                try {
                    message = JSON.parse(event.data);
                } catch (error) {
                    $log.error('event message', error);
                    return;
                }
            }

            if (IntegrationService && angular.isFunction(IntegrationService.handleOnMessage)) {
                IntegrationService.handleOnMessage(event, message);
            }

            if (PaymentFrameService && angular.isFunction(PaymentFrameService.handleOnMessage)) {
                PaymentFrameService.handleOnMessage(event, message);
            }

            if (PaymentOverlayService && angular.isFunction(PaymentOverlayService.handleOnMessage)) {
                PaymentOverlayService.handleOnMessage(event, message);
            }
        });

        $window.document.addEventListener('wheel', function (event) {
            var docEl = $window.document,
                activeElement = docEl && docEl.activeElement;

            if (
                activeElement && activeElement.type === 'number'
            ) {
                activeElement.blur();
            }
        }, modernizr.passiveeventlisteners ? { passive: true } : false);
        if ($window.top != $window.self && !window.__karma__ && AppConfig.INTEGRATION.frameBusterEnabled !== false) { // eslint-disable-line eqeqeq
            try {
                if (!_.includes(AppConfig.INTEGRATION.frameBusterHostnameExcludes, $window.top.location.hostname)) {
                    $window.top.location = $window.self.location;
                }
            } catch (e) {
                $window.top.location = $window.self.location;
            }
        }

        $window.onbeforeunload = function (event) {
            if ($window.self !== $window.top && $window.parent) {
                try {
                    $window.parent.confirmBeforeUnload = true;
                } catch (e) {
                    $log.error('window.onbeforeunload', e);
                }
            } else if ($window.confirmBeforeUnload !== false) {
                event.preventDefault();
                return '';
            }
        };

        $window.onpagehide = function (event) {
            $log.log('iplusjs pagehide', event, $window.removePksRedirectInfos);

            if ($window.removePksRedirectInfos !== false) {
                $window.sessionStorage.removeItem('iframeReload');
                $window.sessionStorage.removeItem('reload');
            }
        };

        $window.onpageshow = function (event) {
            $log.log('iplusjs pageshow', event);
        };
    }
})();
